import {Fragment} from 'react';
import {Button, Grid, Segment} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import Document from '../shared/document';

function Home() {
  return (
    <Segment>
      <h1 className='text-large'>پنل داوطلبان خصوصی گروه مد مشاور</h1>
      <p>داوطلب گرامی، به پنل مشاوره خصوصی گروه مد مشاور خوش آمدید.</p>
      <p>
        جهت ثبت‌نام در پنل مشاوره خصوصی گروه مد مشاور ابتدا فایل‌های
        &nbsp;
        <a
          href={process.env.PUBLIC_URL + '/documents/برنامه آزمون های دستیاری 1404.pdf'}
          rel='noopener noreferrer'
          target='_blank'
        >
          "برنامه آزمون های دستیاری 1404"
        </a>
        &nbsp;
        و
        &nbsp;
        <a
          href={process.env.PUBLIC_URL + '/documents/راهنمای ثبت نام مشاوره خصوصی.pdf'}
          rel='noopener noreferrer'
          target='_blank'
        >
          "راهنمای ثبت نام مشاوره خصوصی"
        </a>
        &nbsp;
        را با دقت مطالعه کنید و در انتهای روی گزینه
        <span className='text-medium'> "ثبت نام مشاوره خصوصی آزمون های دستیاری و پره انترنی" </span>
        کلیک کنید.
      </p>
      <p>
        در صورت بروز هر گونه مشکل با
        <a href='https://t.me/medmoshaver_admin'> اکانت ادمین کانال تلگرام </a>
        به آدرس
        <a href='https://t.me/medmoshaver_admin'> www.t.me/medmoshaver_admin </a>
        در ارتباط باشید.
      </p>
      <Grid centered padded='vertically'>
        <Grid.Row>
          <Grid.Column mobile={8} tablet={6} computer={4}>
            <Document
              url={process.env.PUBLIC_URL + '/documents/برنامه آزمون های دستیاری 1404.pdf'}
              name='برنامه آزمون های دستیاری 1404'
            />
          </Grid.Column>
          <Grid.Column mobile={8} tablet={6} computer={4}>
            <Document
              url={process.env.PUBLIC_URL + '/documents/راهنمای ثبت نام مشاوره خصوصی.pdf'}
              name='راهنمای ثبت نام مشاوره خصوصی'
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Fragment>
        <h2 className='text-large'>آشنایی با فعالیت‌های گروه مد مشاور</h2>
        <p>
          گروه مد مشاور در سال 1396 فعالیت خود را در زمینه ارائه مشاوره و برگزاری آزمون‌های آزمایشی
          در زمینه آزمون دستیاری تخصصی و پیش کارورزی شروع کرد.
          در حال حاضر این گروه با بیش از 20 مشاور از رتبه‌های برتر آزمون رزیدنتی فعالیت خود را ادامه می‌دهد.
          برنامه ارائه شده یک برنامه کاملا منعطف هست که متناسب با زمان و برنامه تحصیلی داوطلبان قابل شخصی سازی می باشد.
        </p>
        <h2 className='text-large'>امکانات سایت مشاوره و گروه مد مشاور</h2>
        <p>
          با ثبت‌نام در این سایت و وارد‌شدن به گروه مشاوره خصوصی، شما علاوه بر برخورداری از خدمات رایگان گروه مد مشاور
          که از طریق شبکه‌های اجتماعی و سایت ارائه می‌شود، خدمات زیر را دریافت خواهید کرد.
        </p>
        <ul>
          <li>
            <span className='text-medium'>ارتباط پیوسته با مشاور:</span>&nbsp;
            به صورت پیوسته از طریق شبکه‌های اجتماعی و مکالمه تلفنی با مشاور اختصاصی خود در ارتباط خواهید بود.
          </li>
          <li>
            <span className='text-medium'>ثبت پیوسته گزارش فعالیت:</span>&nbsp;
            امکان ثبت تکالیف درسی تعیین شده برای شما و مشاهده پیشرفت درسی
          </li>
          <li>
            <span className='text-medium'>توضیحات صوتی روش مطالعه هر درس:</span>&nbsp;
            توضیحات کوتاه برای هر کدام از فصل‌های برنامه اختیار شما خواهد بود که قبل از شروع به مطالعه،
            اطلاعاتی در مورد اهمیت مطالب کسب کنید.
          </li>
          <li>
            <span className='text-medium'>شرکت در آزمون‌های گروه مد مشاور به صورت رایگان:</span>&nbsp;
            آزمون های برنامه ریزی شده به صورت هر دو هفته یکبار برگزار می شود که برای داوطلبان گروه مشاوره خصوصی به صورت
            رایگان توسط مشاور فعال خواهد شد.
          </li>
          <li>
            <span className='text-medium'>انتخاب رشته بعد از آزمون دستیاری:</span>&nbsp;
            داوطلبان آزمون دستیاری که به صورت پیوسته تا آزمون دستیاری عضو گروه مشاوره باشند
            برای مشاوره انتخاب رشته سال بعد در الویت خواهند بود و از تخفیف ویژه برخوردار خواهند بود.
          </li>
          <li>
            <span className='text-medium'>تخفیف خرید تمام محصولات مدمشاور:</span>&nbsp;
            داوطلبان گروه مشاوره خصوصی برای خرید تمام جزوات و محصولات مدمشاور
            از جمله فلش کارت های مدمشاور از تخفیف ویژه برخوردار خواهند بود.
          </li>
        </ul>

        <h2 className='text-large'>روند ثبت نام در سایت گروه مد مشاور</h2>
        <p>
          با کلیک بر روی دکمه ثبت نام،
          شماره تلفن خود را تایید کنید و در نهایت اطلاعات مورد نیاز در فرم ثبت نام را وارد نمایید.
          پس از تکمیل این فرم وارد سایت شده و بسته مشاوره خود را از بین بسته‌های مشاوره انتخاب می‌کنید.
          (مدت زمان اعتبار مشاوره در بسته های مختلف متفاوت است و طرح های تخفیف در طول سال در نظر گرفته می شود.)
          پس از انتخاب بسته و پرداخت آنلاین مشاوره شما فعال شده
          و هماهنگی لازم جهت ارتباط با مشاور اختصاصی با شما انجام خواهد شد.
        </p>
      </Fragment>

      <Grid centered stackable columns={3} padded='vertically'>
        <Button size='large' color='teal' as={Link} to='/register'>
          ثبت‌نام مشاوره خصوصی
        </Button>
      </Grid>
    </Segment>
  );
}

export default Home;
